export default __webpack_public_path__ + "static/media/ic_expense.af7d6aba.svg";